import React from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'

import { MODAL_TYPE } from './Modal'

const LogoBrandsTable = ({ translate, logoBrandsList, changeModal }) => {
  const renderRows = (logoBrands) => (
    <tr key={logoBrands.nmBrand}>
      <td>{logoBrands.nmBrand}</td>
      <td>
        {renderAction('eye', 'primary', MODAL_TYPE.VIEW, logoBrands)}
        {renderAction('pencil', 'primary', MODAL_TYPE.EDIT, logoBrands)}
        {renderAction('trash-can', 'default', MODAL_TYPE.DELETE, logoBrands)}
      </td>
    </tr>
  )

  const renderAction = (type, color, action, currentItem) => (
    <span onClick={() => changeModal(action, currentItem)} className='action'>
      <Glyph type={type} color={color} />
    </span>
  )

  return (
    <table>
      <thead>
        <tr>
          <th>{translate('provider')}</th>
          <th>{translate('actions')}</th>
        </tr>
      </thead>
      <tbody>{logoBrandsList.map(renderRows)}</tbody>
    </table>
  )
}

LogoBrandsTable.propTypes = {
  translate: PropTypes.func.isRequired,
  logoBrandsList: PropTypes.array.isRequired,
  changeModal: PropTypes.func.isRequired,
}

export default LogoBrandsTable
